import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, AlertController, ViewController, NavParams, ModalController } from 'ionic-angular';
import {  } from '../';
import { MasterMarketing as Master, TenderMarketing, SubscriberMarketing as Subscriber  } from '@providers/index';

@Component({
  selector: 'page-select',
  templateUrl: 'page.html'
})
export class SelectPage {

  List: any  = [];
  keyword    = '';
  select_mod : any;
  tender_id  : 0;
  data_user  : any=[];
  
  constructor(
    public navCtrl    : NavController,
    public masterApi  : Master,
    public tenderApi   : TenderMarketing,
    public subsApi    : Subscriber,
    public toastCtrl  : ToastController,
    public loadingCtrl: LoadingController,
    public alertCtrl  : AlertController,
    public viewCtrl   : ViewController,
    public modalCtrl  : ModalController,
    public navParams  : NavParams
  ) {
    this.select_mod = this.navParams.get('select_mod');
    this.tender_id  = this.navParams.get('tender_id');
    this.data_user  = JSON.parse(localStorage.data_user);
    console.log("user login =>",this.data_user);
    console.log("Select Mod => ", this.select_mod);
  }

  ionViewDidEnter() {
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message : msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  getList(keyword=''){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params:any = {
      
    };
    if(keyword!=''){
      params.keyword=keyword;
    }

    let get : any; 
    if(this.select_mod == 3){
      get = this.masterApi.getCompanyWinner(params);
    }else{
      params.modul_id=3
      get = this.subsApi.getEmployee(params);
    }

      get.subscribe((resp:any) => {
        this.List = resp.data;
        loading.dismiss();
      }, (err) => {
        loading.dismiss();
        console.log(err);
      });
    
  }

  select(item){
    if(this.select_mod == 1){
      let params = {
        notification_code : 'new_tender_note',
        reference_id      : this.tender_id,
        user_id           : item.user_id,
        created_by        : this.data_user.data.user_id,
      };
      
        this.subsApi.addSubscriber(params).subscribe((resp:any) => {      
  
        this.closeModal();
        });
    }
    if(this.select_mod == 2 || this.select_mod == 3){
      let data = { item:item };
      this.viewCtrl.dismiss(data);
    }
    else{
      
    }
  }

  onInput(e){
    this.getList(this.keyword);
  }

  onCancel(e){
    this.getList();
  }

  closeModal(){
    let data = {item:''};
    this.viewCtrl.dismiss(data);
  }

  saveCompanyWinner(company_name){
    let params = {
      company_name : company_name,
    }

    this.masterApi.postCompanyWinner(params).subscribe((resp:any) => {
      this.getList();
    });
  }

  addCompanyWinner(){
    let form = this.alertCtrl.create({
      title:'Form Company',
      inputs:[
        {
          name: 'company_name',
          placeholder:'Company Name'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Add',
          handler: data => {
            if (data.company_name!='') {
              console.log('company name => ', data.company_name);
              this.saveCompanyWinner(data.company_name);
            } else {
              this.presentToast('Nama Company tidak booleh kosong !')
              return false;
            }
          }
        }
      ]
    });

    form.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/marketing/select/page.ts